module.exports = "<div class=\"\">\r\n        <div class=\"col-md-12 margins\">\r\n          <div class=\"alert alert-warning alert-dismissible fade in\" role=\"alert\">\r\n                You are not authorised to view this page.\r\n          </div>\r\n        </div>\r\n      </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/forbidden/forbidden.component.html
// module id = ./src/app/shared/forbidden/forbidden.component.html
// module chunks = main